import * as React from "react";
const SvgSolidity = (props) => /* @__PURE__ */ React.createElement("svg", { width: "800px", height: "800px", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", fill: "#000000", ...props }, /* @__PURE__ */ React.createElement("g", { id: "SVGRepo_bgCarrier", strokeWidth: 0 }), /* @__PURE__ */ React.createElement("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("g", { id: "SVGRepo_iconCarrier" }, /* @__PURE__ */ React.createElement("title", null, "file_type_solidity"), /* @__PURE__ */ React.createElement("path", { d: "M20.477,2l-4.5,8h-9l4.5-8h9", style: {
  fill: "#006eff",
  opacity: 0.45,
  isolation: "isolate"
} }), /* @__PURE__ */ React.createElement("path", { d: "M11.52,30l4.5-8h9l-4.5,8h-9", style: {
  fill: "#006eff",
  opacity: 0.45,
  isolation: "isolate"
} }), /* @__PURE__ */ React.createElement("path", { d: "M15.975,10h9l-4.5-8h-9Z", style: {
  fill: "#006eff",
  opacity: 0.6,
  isolation: "isolate"
} }), /* @__PURE__ */ React.createElement("path", { d: "M16.022,22h-9l4.5,8h9Z", style: {
  fill: "#006eff",
  opacity: 0.6,
  isolation: "isolate"
} }), /* @__PURE__ */ React.createElement("path", { d: "M11.477,18l4.5-8-4.5-8-4.5,8Z", style: {
  fill: "#006eff",
  opacity: 0.8,
  isolation: "isolate"
} }), /* @__PURE__ */ React.createElement("path", { d: "M20.52,14l-4.5,8,4.5,8,4.5-8Z", style: {
  fill: "#006eff",
  opacity: 0.8,
  isolation: "isolate"
} })));
export default SvgSolidity;
